import PropTypes from 'prop-types'
import { Typography } from '../styled'
import { ProgressWrapper, ProgressTrack, ProgressFill } from './styled'

function FeedbackProgressBar({ progress, label }) {
  return (
    <ProgressWrapper>
      <Typography
        size="13px"
        bold
        style={{ width: '120px', whiteSpace: 'nowrap' }}
      >
        {progress}% {label}
      </Typography>
      <ProgressTrack>
        <ProgressFill progress={progress} />
      </ProgressTrack>
    </ProgressWrapper>
  )
}

FeedbackProgressBar.propTypes = {
  progress: PropTypes.number,
  label: PropTypes.string,
}

export default FeedbackProgressBar
